
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startListadoProveedores, startProveedorXID } from "../../../services";






export const useProveedorXID = (id) => {
    const proveedorXIDQuery = useQuery({
        queryKey: ['proveedor-id', id], 
        queryFn: () => startProveedorXID(id),
    });

    return { proveedorXIDQuery }
}






export const useProveedoresQuery = () => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const proveedoresListQuery = useQuery({
        queryKey: ['proveedores-list', { page, termino }], 
        queryFn: () => startListadoProveedores({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        proveedoresListQuery,
    }
}
